export default {
  'toolbar.undo': 'Undo',
  'toolbar.redo': 'Redo',
  'toolbar.addChild': 'Add Child',
  'toolbar.edit': 'Edit',
  'toolbar.delete': 'Delete Node',
  'toolbar.resetView': 'Reset View',
  'toolbar.zoomIn': 'Zoom In',
  'toolbar.zoomOut': 'Zoom Out',
  'node.addChild': 'Add Child',
  'node.addSibling': 'Add Sibling',
  'node.delete': 'Delete Node',
  'node.edit': 'Edit Node',
  'node.copy': 'Copy',
  'node.cut': 'Cut',
  'node.paste': 'Paste',
  'node.defaultText': 'New Node',
};
